<template>
  <div>
    <ul v-if="quizList.length > 0 " class="exams-list">
      <li v-for="q in quizList" :key="q.id" class="has-answered">
        <div class="exam-info-bar">
          <span class="exam-title">{{q.title}}</span>
          <span class="exam-grade">{{q.moduleName}}</span>
          <span class="exam-grade-number">{{q.grade}}%</span>
          <span class="exam-status">
            <toggle-button
              :disabled="savingQuiz"
              @change="toggleApproved(q)"
              :value="q.approved"
              :color="{checked: '#4ebcd7', unchecked: '#dc3545'}"
              :width="90"
              :sync="true"
              :labels="{checked: 'Aprovado', unchecked: 'Reprovado'}"
            />
          </span>
          <p></p>

          <!-- <quiz-button class="primary" :loading="false" @click="openQuizModal(q)">visualizar</quiz-button> -->
        </div>
      </li>
    </ul>

    <div v-else class="placeholder-message">
      <h5>Nenhuma avaliação realizada</h5>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import QuizButton from "../../Buttons/QuizButton";
//import ViewQuiz from "./ViewQuiz";

export default {
  props: {
    quizList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      test: false,
      savingQuiz: false
    };
  },
  components: {
    QuizButton
  },
  methods: {
    toggleApproved(quiz) {
      let approved = false;
      if (quiz.approved == false) {
        approved = true;
      }
      console.log(approved);
      this.savingQuiz = true;

      const path = this.$global.endpoint + "/quiz/execution/updateapproved";
      axios
        .post(path, {
          userId: quiz.userId,
          quizId: quiz.id,
          approved: approved
        })
        .then(res => {
          this.savingQuiz = false;
          this.$emit("update");
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Dados da avaliação atualizados"
          });
        })
        .catch(error => {
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao atualizar os dados"
          });
        });
    }
  },
  created() {}
};
</script>
